import { MergeObjects } from './../core/library/objects';
import MediaSources from './media_sources';
import * as Projects from './projects';
import {parseUrlParams} from "../core/library/url";
import PushRegions from './regions';

const PROJECT = process.env.PROJECT || "";


let Config = {
    LOCALE: "ru",
    PROJECT_PREFIX: "test",
    RESIZER: false,
    // project config
    PROJECT: {
        // project name
        NAME: PROJECT,
        // project default layout
        LAYOUT: "default",
        // project api path
        API: `http://localhost:8086/api/backend`,
    },

    // oauth configuration
    OAUTH: {
        // url for oauth domain
        URL: `https://oauth.absatz.media`,
        // current project domain
        PROJECT_DOMAIN: `localhost:3000`,
        // current project url path
        PROJECT_PATH: `http://localhost:3000`,
        // path for oauth api
        API: `https://oauth.absatz.media/auth`,
        // path for oauth users
        OAUTH_USER_PATH: `https://oauth.absatz.media/users/`,
        // prefix for authorization tokens
        PREFIX: 'oauth_',
    },
    // default date format
    DATE_FORMAT: "DD-MM-YYYY HH:mm",
    // configuration for slug plugin
    SLUG: {
        delimiter: '-',
        prefix: ''
    },

    // configuration for media
    MEDIA: {
        // path for cdn content
        CDN: {
            IMAGES: "https://cdni.rbth.com/rbthmedia/images",
            VIDEO: "https://cdni.rbth.com/rbthmedia/video"
        },
        // available copyright sources
        SOURCES: MediaSources,
        // available upload types
        UPLOAD_AVAILABLE: ['jpg','gif','png','jpeg','mp4','mp3'],
        // available embedded sources
        EMBEDDED_SOURCES: ['youtube.com', 'facebook.com', 'youtu.be'],
        EMEDDED_PREPARE: {
            'youtu.be': (path) => {
                let params = path.split('/');
                return (
                    `<iframe width="560" height="315" src="https://www.youtube.com/embed/${params[params.length - 1]}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
                );
            },
            'youtube.com': (path) => {
                let p = parseUrlParams(path);
                if (!p.v) return ``;
                return (
                    `<iframe width="560" height="315" src="https://www.youtube.com/embed/${p.v}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
                );
            },
            'facebook.com': (url) => {
                return (
                    `<iframe src="https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&width=500&show_text=false&appId=526970354336335&height=280" width="500" height="280" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media" allowFullScreen="true"></iframe>`
                )
            },
        },
    },

    DOCUMENTS: {
        STATUS: ["published", "unpublished", "prepublished_status"],
        MOVE_TYPES: ['Articles', 'Films', 'Music', 'Books', 'Online_performances', 'Museum', 'Courses', 'Units', 'Lessons', 'Russian_ltext', 'Russian_lmems', 'Russian_lvideos', 'Useful_articles', 'Trips'],
        LANGUAGES_CHANGE_FOR: ['Articles', 'Films', 'Music', 'Books', 'Online_performances', 'Museum', 'Courses', 'Units', 'Lessons', 'Russian_ltext', 'Russian_lmems', 'Russian_lvideos', 'Useful_articles', 'Trips'],
    },
    EDITOR: {
        KEY: "clzzivqs4p1bb1eoei67nmbzwwzio5uv0w69ew52cc8ex5s7",
        SETTINGS: {
            language: 'ru',
        },
    },
    MAPS: {
        KEY: "e70f3b03-0677-45b8-911f-830daf383e37",
    },
    ELASTIC: {
        API: "http://localhost:8009/elastic"
    },
    MEDIA_DATABASE_TYPES: ['Image', 'Video', 'ExternalVideo', 'Code'],
    MEDIA_AVAILABLE_TYPES: '.jpg,.gif,.png,.jpeg,.mp4,.mp3',
    MEDIA_AVAILABLE_SOURCES: ['youtube', 'vimeo', 'facebook'],
    WIDGETS: {
        TYPES: ['Article', 'News', 'Episode', 'Infographic','Meaning', 'Trend', 'Banner', 'Show', 'Polls', 'Receipt']
    },
    REGIONS: PushRegions,
    PHOTO_AUTHORS: [],
    SPECIAL_PROJECT_TYPES: ['Фотовыставка', 'Спец. репортаж', 'Выставка', 'Специальный материал'],
    CROPPER: {
        WIDTH: 1200,
        HEIGHT: 675,
    },
    DEFAULT_CROSSLINKS_TYPES: 'Films,Serials,Episodes,News,Stories,Stories_cards,Quiz'
};

if(Projects[PROJECT]) {
    Config = MergeObjects(Config, Projects[PROJECT]);
}

window.APP_CONFIG = {
    PROJECT: Config.PROJECT,
    MEDIA: Config.MEDIA,
};


export const IsLocal = window.location.hostname === 'localhost';

export const LanguagesAdmDomains = {
    "67192520dc76de7247771b01": "cn-backend.gw2ru.com",
    "671924f8dc76de7247771afd": "Македонски",
    "671924d7dc76de7247771af9": "Slovenščina",
    "671924aadc76de7247771af5": "Hrvatski",
    "6719246adc76de7247771af1": "Български",
    "67192433dc76de7247771aed": "br-backend.gw2ru.com",
    "67192425dc76de7247771ae9": "fr-backend.gw2ru.com",
    "67192414dc76de7247771ae5": "de-backend.gw2ru.com",
    "671923cedc76de7247771ae1": "rs-backend.gw2ru.com",
    "671923b9dc76de7247771add": "jp-backend.gw2ru.com",
    "6719239fdc76de7247771ad9": "Italiano",
    "67192386dc76de7247771ad4": "es-backend.gw2ru.com",
    "6719235adc76de7247771ad0": "Indonesian",
    "6719233edc76de7247771acc": "ru-backend.gw2ru.com",
    "67192300dc76de7247771ac8": "backend.gw2ru.com",
    "67684e8cdc76de7cfcad4918": "Languages",
    "686bbf7ddc76de5423b0274b": "hi-backend.gw2ru.com",
    "686bcc45dc76de5423b02840": "ar-backend.gw2ru.com",
}


export const LanguagesAdmDomainsLanguagesCodes = {
    "67192520dc76de7247771b01": "zh-CN",
    "671924f8dc76de7247771afd": "MK",
    "671924d7dc76de7247771af9": "SL",
    "671924aadc76de7247771af5": "HR",
    "6719246adc76de7247771af1": "BG",
    "67192433dc76de7247771aed": "PT",
    "67192425dc76de7247771ae9": "FR",
    "67192414dc76de7247771ae5": "DE",
    "671923cedc76de7247771ae1": "SI",
    "671923b9dc76de7247771add": "JP",
    "6719239fdc76de7247771ad9": "IT",
    "67192386dc76de7247771ad4": "ES",
    "6719235adc76de7247771ad0": "id",
    "6719233edc76de7247771acc": "ru-RU",
    "67192300dc76de7247771ac8": "en-US",
    "67684e8cdc76de7cfcad4918": "Languages",
    "686bbf7ddc76de5423b0274b": "hi",
    "686bcc45dc76de5423b02840": "ar",
};

export const AdminMultiLangTypes = ['Languages', 'Category', 'Tags', 'Trends', 'Authors'];

export const AdmLessonsTypes = ['Courses', 'Units', 'Lessons', 'Tests'];


export const LanguageStorageKey = 'gw_lang_r'
export const LanguageDirectionKey = 'gw_lang_d'

export const FilterMapAliases = {
    'articles': {
        'Category': 'Categories',
    }
};

export const GetFilterObjectAlias = (docType = '', loadType = '') => {
    console.log('filter type', docType, loadType)
    if (FilterMapAliases[docType] && FilterMapAliases[docType][loadType]) {
        return FilterMapAliases[docType][loadType];
    }
    return loadType;
}

export const GetItemLanguagesTitles = (languages = []) => {
    if (!languages || languages.length === 0) {
        return null;
    }
    return languages.map(i => {
        let fLanguage = window.AL_LIST.Languages.filter(j => {
            if (i.id && i.id === j.id) {
                return true;
            }
            return j.id === i;
        })
        return fLanguage && fLanguage.length > 0 ? fLanguage[0].title : i;
    });
}


export const GetDocumentTitle = (doc) => {
    if (doc.title_locale && Object.keys(doc.title_locale).length > 0) {
        return Object.keys(doc.title_locale).map(i => doc.title_locale[i]).join(' / ');

    }
    return doc.title || `[not set]`
}


export const CUSTOM_SEARCH_TYPES =  ['Authors', 'Tags', 'Trends', 'Categories', 'Media_selection', 'Person', 'Pa_theater', 'Genre', 'Copyright', 'Music_authors'];

export default Config;


